import './bml-expertise-banner.scss';
const TEMPLATE = `
<section class="expertise-banner fade-up">
    <!-- Контейнер з колами -->
    <div class="expertise-circle-container d-none d-md-block">
        <div class="circle-expertise first-circle"></div>
        <div class="circle-expertise second-circle"></div>
        <div class="circle-expertise third-circle"></div>
    </div>

    <h1 data-animate-child>Достовірна діагностика для точних клінічних рішень</h1>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">

            </div>
            <div class="col-12 col-lg-6 col-md-6">
                <p data-animate-child>Ми поєднуємо патоморфологічні, генетичні та біохімічні дослідження, щоб
                    забезпечити лікарів перевіреними результатами. У BML кожен етап контролюється міжнародними
                    стандартами якості для швидких і надійних клінічних рішень.</p>
                <button class="main-banner-link" data-animate-child data-bs-toggle="modal" data-bs-target="#nomenclatureModal">
                    Переглянути послуги
                </button>
            </div>
        </div>
    </div>

</section>
`;

class BmlExpertiseBanner extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
        this.querySelector('button.main-banner-link')?.addEventListener('click', () => {
            document.querySelector('bml-nomenclature #nomenclature-open-btn')?.click();
        });
    }
}
customElements.define('bml-expertise-banner', BmlExpertiseBanner);
